// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__15qYM","footer":"Form_footer__24m6P"};